module.exports = __webpack_public_path__ + "static/media/ActivitySub3.98337fb0.png";